import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login"); // login | register
  const [loading, setLoading] = useState(false);

  // Login fields
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  // Register fields
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone2, setPhone2] = useState("");
  const [pass2, setPass2] = useState("");

  const handleLogin = async () => {
    if (!phone || !password) {
      toast.error("Fill in all fields");
      return;
    }
    setLoading(true);
    try {
      await login(phone, password);
      toast.success("Welcome back!");
      navigate("/orders");
    } catch (e) {
      toast.error(e.response?.data?.message || "Login failed");
    }
    setLoading(false);
  };

  const handleRegister = async () => {
    if (!name || !phone2 || !pass2) {
      toast.error("Fill in all required fields");
      return;
    }
    if (pass2.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      await register({
        name,
        phone: phone2,
        email: email || undefined,
        password: pass2,
      });
      toast.success("Account created!");
      navigate("/");
    } catch (e) {
      toast.error(e.response?.data?.message || "Registration failed");
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "100px 6% 60px",
      }}
    >
      {/* BG glow */}
      <div
        style={{
          position: "fixed",
          top: "30%",
          left: "50%",
          transform: "translateX(-50%)",
          width: 600,
          height: 400,
          background:
            "radial-gradient(ellipse,rgba(245,166,35,0.07) 0%,transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          width: "100%",
          maxWidth: 440,
          animation: "fadeUp 0.5s ease both",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <Link to="/" style={{ display: "inline-block", marginBottom: 24 }}>
            <img
              src="/logo.png"
              alt="KwiKie"
              style={{ height: 40, width: "auto" }}
            />
          </Link>
          <h1
            style={{
              fontSize: 28,
              fontWeight: 800,
              letterSpacing: "-1px",
              marginBottom: 8,
            }}
          >
            {mode === "login" ? "Welcome back" : "Create account"}
          </h1>
          <p style={{ fontSize: 14, color: "var(--text2)" }}>
            {mode === "login"
              ? "Sign in to track your deliveries"
              : "Place deliveries and track orders"}
          </p>
        </div>

        {/* Toggle */}
        <div
          style={{
            display: "flex",
            background: "var(--bg3)",
            borderRadius: 10,
            padding: 4,
            marginBottom: 28,
            border: "1px solid var(--border)",
          }}
        >
          {[
            ["login", "Sign In"],
            ["register", "Create Account"],
          ].map(([m, label]) => (
            <button
              key={m}
              onClick={() => setMode(m)}
              style={{
                flex: 1,
                padding: "9px 12px",
                borderRadius: 8,
                border: "none",
                background: mode === m ? "var(--bg4)" : "transparent",
                color: mode === m ? "var(--text)" : "var(--text3)",
                fontFamily: "var(--font-head)",
                fontWeight: 700,
                fontSize: 13,
                cursor: "pointer",
                transition: "all 0.15s",
                boxShadow: mode === m ? "0 2px 8px rgba(0,0,0,0.3)" : "none",
              }}
            >
              {label}
            </button>
          ))}
        </div>

        <div
          style={{
            background: "var(--bg2)",
            border: "1px solid var(--border)",
            borderRadius: 16,
            padding: 32,
          }}
        >
          {mode === "login" ? (
            <>
              <div className="form-group">
                <label className="form-label">Phone Number</label>
                <input
                  className="form-input"
                  placeholder="+233 XX XXX XXXX"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Password</label>
                <input
                  className="form-input"
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                />
              </div>
              <button
                className="btn-primary"
                style={{
                  width: "100%",
                  justifyContent: "center",
                  marginTop: 8,
                }}
                onClick={handleLogin}
                disabled={loading}
              >
                {loading ? <span className="spinner" /> : "Sign In →"}
              </button>
            </>
          ) : (
            <>
              <div className="form-group">
                <label className="form-label">Full Name *</label>
                <input
                  className="form-input"
                  placeholder="Kwame Mensah"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Phone Number *</label>
                <input
                  className="form-input"
                  placeholder="+233 XX XXX XXXX"
                  value={phone2}
                  onChange={(e) => setPhone2(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Email (optional)</label>
                <input
                  className="form-input"
                  type="email"
                  placeholder="you@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Password *</label>
                <input
                  className="form-input"
                  type="password"
                  placeholder="Min. 6 characters"
                  value={pass2}
                  onChange={(e) => setPass2(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleRegister()}
                />
              </div>
              <button
                className="btn-primary"
                style={{
                  width: "100%",
                  justifyContent: "center",
                  marginTop: 8,
                }}
                onClick={handleRegister}
                disabled={loading}
              >
                {loading ? <span className="spinner" /> : "Create Account →"}
              </button>
            </>
          )}
        </div>

        <p
          style={{
            textAlign: "center",
            fontSize: 13,
            color: "var(--text3)",
            marginTop: 20,
          }}
        >
          <Link to="/" style={{ color: "var(--accent)" }}>
            ← Back to home
          </Link>
        </p>
      </div>
    </div>
  );
}
